import Point from "./Point";

export class Vector extends Point {
  x: number;
  y: number;

  constructor(radians, length) {
    const x = Math.cos(radians) * length;
    const y = Math.sin(radians) * length;
    super(x, y);

    this.x = x;
    this.y = y;
  }

  update(radians, length) {
    this.x = Math.cos(radians) * length * -1;
    this.y = Math.sin(radians) * length * -1;
  }
}
